import type { participation as en } from '@/i18n/locales/en/participation';
import type { Translation } from '@/i18n/types';

export const participation: Translation<typeof en> = {
  page: {
    title: 'Participação',
    lead: 'O funil de envolvimento: de convidado a estruturalmente ativo, mais as taxas de envolvimento diárias.',
    noScope: 'Selecione uma empresa para ver os números de participação.',
    noDepartments: 'Nenhum departamento aqui tem estatísticas que você pode ver.',
    disclaimer:
      'Todos os valores são indicações de bem-estar e não constituem um diagnóstico médico. As tendências só são mostradas com um número suficiente de participantes (privacidade desde a conceção).',
  },
  filters: {
    department: {
      label: 'Departamento',
    },
    location: {
      label: 'Localização',
      all: 'Todas as localizações',
    },
  },
  funnel: {
    title: 'Funil de envolvimento',
    pctOfPrevious: '{{pct}}% da etapa anterior',
    steps: {
      invited: 'Convidados',
      activated: 'Ativados',
      active_7d: 'Ativos (7d)',
      active_30d: 'Ativos (30d)',
      structurally_active: 'Estruturalmente ativos',
      needs_reactivation: 'A reativar',
    },
  },
  rates: {
    title: 'Taxas de envolvimento',
    keys: {
      daily_sync_pct: 'Sincronização diária',
      ai_coach_use_pct: 'Uso do coach de IA',
      challenge_participation_pct: 'Participação em desafios',
      notification_open_pct: 'Aberturas de notificações',
      break_adoption_pct: 'Adoção de pausas',
      focus_rhythm_pct: 'Ritmo de foco',
    },
  },
  breakdown: {
    department: 'Por departamento',
    location: 'Por localização',
    pilotGroup: 'Por grupo piloto',
    empty: 'Ainda não há dados para detalhar.',
    pilotGroupEmpty: 'Ainda nenhum piloto abrange este departamento.',
    ratio: '{{activated}}/{{invited}} · {{pct}}%',
    shielded: {
      badge: 'Protegido',
      message:
        'Participantes insuficientes ({{invited}}) para uma visualização segura em termos de privacidade — são necessários pelo menos {{min}}.',
    },
    columns: {
      name: 'Nome',
      invited: 'Convidados',
      activated: 'Ativados',
      active30d: 'Ativos (30d)',
    },
  },
  status: {
    noData: '—',
  },
};
